import React from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import "./Receipts.scss";
import PaymentReceipt from "./PaymentReceipt";

const Receipts = ({ }) => {
  return (
    <>
      <Header />
      <section className="dashboard-main receipts-page">
        <div className="dashboard-wrapper">
          <div className="content-block">
            <PaymentReceipt />
          </div>
        </div>
      </section>
      <div className="footer-block">
        <Footer />
      </div>
    </>
  );
};

export default Receipts;